export class InvoiceHistory {
  id: number;
  action: string;
  userName: string;
  date: Date;

  get description(): string {
    if (this.action === 'CREATE') {
      return 'aangemaakt';
    }
    if (this.action === 'UPDATE') {
      return 'aangepast';
    }
    if (this.action === 'EMAIL') {
      return 'email in de wachtrij gezet';
    }
    if (this.action === 'MAILED') {
      return 'email verzonden';
    }
    if (this.action === 'DOWNLOAD') {
      return 'pdf gedownload';
    }
    if (this.action === 'DOWNLOADMERGED') {
      return 'gedownload in een samengevoegde PDF';
    }
    if (this.action === 'DOWNLOADZIP') {
      return 'gedownload in een ingepakte ZIP';
    }
    if (this.action === 'PAYMENT') {
      return 'betaling geregistreerd';
    }

    return this.action;
  }
}
